/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React, { useContext } from 'react';
import { MapActionsContext, useSelectorWithMapId } from '../map/BaseMapContainer';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  selectGpsSaLowAccuracyMapLayers,
  selectGpsSaMapLayersLowAccuracyChecked,
  selectGpsSaMapLayersNormalAccuracyChecked,
  selectGpsSaMapLayersReducedAccuracyChecked,
  selectGpsSaNormalAccuracyMapLayers,
  selectGpsSaReducedAccuracyMapLayers,
} from '../../../store';
import { DISABLED_OPACITY, ENABLED_OPACITY } from './overlaysDefn';
import appTheme from '../../common/theme/appTheme.json';
import GpsSaAccuracyCheckbox from './GpsSaAccuracyCheckbox';

export function GpsSaMapLayerControlCheckboxes() {
  const dispatch = useDispatch();
  const mapActionsContext = useContext(MapActionsContext);

  const {
    setGpsSaMapLayersNormalAccuracyChecked,
    setGpsSaMapLayersReducedAccuracyChecked,
    setGpsSaMapLayersLowAccuracyChecked,
  } = mapActionsContext.mapActions;

  const normalAccuracyMapLayers = useSelector(selectGpsSaNormalAccuracyMapLayers, shallowEqual);
  const reducedAccuracyMapLayers = useSelector(selectGpsSaReducedAccuracyMapLayers, shallowEqual);
  const lowAccuracyMapLayers = useSelector(selectGpsSaLowAccuracyMapLayers, shallowEqual);

  const normalAccuracyChecked = useSelectorWithMapId(selectGpsSaMapLayersNormalAccuracyChecked);
  const reducedAccuracyChecked = useSelectorWithMapId(selectGpsSaMapLayersReducedAccuracyChecked);
  const lowAccuracyChecked = useSelectorWithMapId(selectGpsSaMapLayersLowAccuracyChecked);

  return (
    <>
      <GpsSaAccuracyCheckbox
        label="Normal Accuracy"
        opacity={normalAccuracyMapLayers.length === 0 ? DISABLED_OPACITY : ENABLED_OPACITY}
        checked={normalAccuracyMapLayers.length === 0 ? false : normalAccuracyChecked}
        disabled={normalAccuracyMapLayers.length === 0}
        onChange={(_event, checked) => dispatch(setGpsSaMapLayersNormalAccuracyChecked(checked))}
        color={appTheme.normalAccuracyGreen}
      />
      <GpsSaAccuracyCheckbox
        label="Reduced Accuracy"
        opacity={reducedAccuracyMapLayers.length === 0 ? DISABLED_OPACITY : ENABLED_OPACITY}
        checked={reducedAccuracyMapLayers.length === 0 ? false : reducedAccuracyChecked}
        disabled={reducedAccuracyMapLayers.length === 0}
        onChange={(_event, checked) => dispatch(setGpsSaMapLayersReducedAccuracyChecked(checked))}
        color={appTheme.reducedAccuracyYellow}
      />
      <GpsSaAccuracyCheckbox
        label="Low Accuracy"
        opacity={lowAccuracyMapLayers.length === 0 ? DISABLED_OPACITY : ENABLED_OPACITY}
        checked={lowAccuracyMapLayers.length === 0 ? false : lowAccuracyChecked}
        disabled={lowAccuracyMapLayers.length === 0}
        onChange={(_event, checked) => dispatch(setGpsSaMapLayersLowAccuracyChecked(checked))}
        color={appTheme.lowAccuracyRed}
      />
    </>
  );
}

export default GpsSaMapLayerControlCheckboxes;
